import React, { useContext, useEffect, useState } from "react";
import { getProjectDetails, AddProjectAssignes } from "./ProjectService";
import { getEmployeeAddProject } from "../MyProfile/Service/profileService";
import { MultiSelect } from "primereact/multiselect";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { Dialog } from "primereact/dialog";
import { useFormik } from "formik";
import * as Yup from "yup";
import Preloader from "../../../Shared/Sidebar/Preloader";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import moment from "moment";

function ProjectDetail() {
  const [projectDetail, setProjectDetail] = useState([]);
  const [loader, setLoading] = useState(true);
  const [showAssignProjectModal, setShowAssignProjectModal] = useState(false);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [checkEmp, setcheckEmp] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [projectId, newprojectId] = useState(0);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const { showLoading, hideLoading } = useContext(LoaderContext);
  useEffect(() => {
    getProjectDetailData();
    fetchEmployeeData();
  }, []);

  async function getProjectDetailData() {
    showLoading();
    const param = {
      ProjectId: 0,
      OrgId: Number(userDetails.OrgId),
      LoggedInUserId: Number(userDetails.EmpId),
    };
    try {
      let projectDetailData = await getProjectDetails(param);
      setProjectDetail(projectDetailData?.Data);
      hideLoading();
    } catch {
      hideLoading();
    }
  }

  const handleCloseProjectModal = () => {
    setShowAssignProjectModal(false);
    setSelectedEmployees([]);
  };

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: 0,
      LoggedInEmployeeId: 0,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: 0,
             IsSuggestedOnly: 0,
    };
    showLoading();
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeeDetails(employeesList.Data);
      hideLoading();
    } catch (error) {
      hideLoading();
    }
  }

  function getProjectId(id) {
    newprojectId(id);
  }

  async function saveProjectAssign() {
    if (selectedEmployees?.length >= 1) {
      showLoading();
      setcheckEmp(false);
      let EmpId = selectedEmployees.map((item) => item.EmpId).join(",");
      const params = {
        Id: 0,
        ProjectId: projectId,
        EmpId: EmpId,
        AssignDate: new Date(),
      };
      let projectAssign = await AddProjectAssignes(params);
      if (projectAssign.status !== 200) {
        hideLoading();
        return false;
      } else {
        handleCloseProjectModal();
        hideLoading();
      }
    } else {
      setcheckEmp(true);
    }
  }

  const handleCloseAddProjectModal = () => {
    setShowProjectModal(false);
  };

  const projectValidation = Yup.object().shape({
    projectName: Yup.string().required("Project name is required"),
    projectDescription: Yup.string().required(
      "Project description is required"
    ),
    projectStatusId: Yup.string().required("Project status Id is required"),
    projectStartDate: Yup.string().required("Project startdate is required"),
    projectEndDate: Yup.string().required("Project  end date is required"),
    projectkickOffDate: Yup.string().required(
      "Project kick Off date is required"
    ),
    projectTechnology: Yup.string().required("Project technology is required"),
    projectCode: Yup.string(),
  });

  const projectForm = useFormik({
    initialValues: {
      projectName: "",
      projectDescription: "",
      projectStatusId: 0,
      projectStartDate: "",
      projectEndDate: "",
      projectkickOffDate: "",
      projectTechnology: "",
      projectCode: "",
    },
    validationSchema: projectValidation,
    onSubmit: async (data) => {
      showLoading();
      const params = {
        Id: 0,
        OrgId: 0,
        ProjectName: data?.projectName,
        ProjectDescription: data?.projectDescription,
        ProjectStatusId: data?.projectStatusId,
        ProjectStartDate: new Date(data?.projectStartDate).toISOString(),
        ProjectEndDate: new Date(data?.projectEndDate).toISOString(),
        ProjectkickOffDate: new Date(data?.projectkickOffDate).toISOString(),
        ProjectTechnology: data?.projectTechnology,
        ProjectCode: data?.projectCode,
      };
      let projectList = await getEmployeeAddProject(params);
      if (projectList.status !== 200) {
        hideLoading();
        return false;
      } else {
        getProjectDetailData();
        handleCloseAddProjectModal();
        hideLoading();
      }
    },
  });

  return (
    <div>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Project</h2>
            </div>
            <div className="org-add" style={{ cursor: "pointer" }}>
              <i
                className="fa fa-plus"
                title="Add Project"
                data-bs-toggle="modal"
                data-bs-target="#assign"
                onClick={() => setShowProjectModal(true)}
              ></i>
            </div>
          </div>

          <div className="row">
            {projectDetail.map((project, index) => {
              return (
                <div className="col-xl-4">
                  <div className="card">
                    <div className="card-body mb-0 awards-div-list">
                      <div className="row">
                        <div className="col-8">
                          <h5 className="card-title">
                            {project?.ProjectName}
                            <span
                              style={{
                                background: "#fbfbfb",
                                float: "right",
                              }}
                            >
                              <a
                                className="edit-btncss mb-2 love-icon"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-bs-toggle="modal"
                                data-bs-target="#assign"
                                title="Assign"
                                data-bs-original-title="Appreciate"
                                aria-label="Appreciate"
                                onClick={() => {
                                  setShowAssignProjectModal(true);
                                  getProjectId(project.Id);
                                }}
                              >
                                <img
                                  src="/images/assign-1.png"
                                  className="w-100"
                                />
                              </a>
                            </span>
                          </h5>
                          <strong>{project?.ProjectCode}</strong>
                          <ul>
                            <li>{project?.ProjectDescription}.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer awards-div-list2">
                      Start Date:{" "}
                      {moment(project?.ProjectStartDate).format("MMM DD YYYY")}
                      End Date:{" "}
                      {moment(project?.ProjectEndDate).format("MMM DD YYYY")}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Dialog
          visible={showAssignProjectModal}
          style={{ width: "35vw" }}
          onHide={() => {
            if (!showAssignProjectModal) return;
            setShowAssignProjectModal(false);
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">Assign Project</h5>
            </div>
            <div className="modal-body">
              <img src="/images/org-img/profile/modal-headimg.png" />
              <div className="addcourseform">
                <div className="row">
                  <div className="card flex justify-content-center">
                    <MultiSelect
                      value={selectedEmployees}
                      onChange={(e) => {
                        setSelectedEmployees(e.value);
                        setcheckEmp(false);
                      }}
                      options={employeDetails}
                      optionLabel="FullName"
                      placeholder="Select Employee"
                      maxSelectedLabels={3}
                      className="w-full md:w-20rem custom-multiselect"
                    />
                  </div>
                  {checkEmp && (
                    <div
                      className="invalid-feedback"
                      style={{ fontWeight: "600" }}
                    >
                      Employee name is required
                    </div>
                  )}
                </div>
                <div className="modal-footer m-auto">
                  <button
                    type="button"
                    className="cancel-click"
                    data-bs-dismiss="modal"
                    onClick={handleCloseProjectModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click"
                    onClick={saveProjectAssign}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
        {showProjectModal && (
          <div
            className="modal fade show"
            id="assign"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title m-auto">Add/Edit Project</h5>
                </div>
                <div className="modal-body">
                  <img src="/images/org-img/profile/modal-headimg.png" />
                  <div className="addcourseform">
                    <form onSubmit={projectForm.handleSubmit}>
                      <div className="row">
                        <div className="mb-4 col-md-12">
                          <input
                            type="text"
                            cols="1"
                            rows="4"
                            name="projectName"
                            className={
                              "form-control bg-chng" +
                              (projectForm.errors.projectName &&
                              projectForm.touched.projectName
                                ? " is-invalid"
                                : "")
                            }
                            onChange={projectForm.handleChange}
                            value={projectForm.values.projectName}
                            placeholder="Project Name goes here..."
                          />
                        </div>
                        <div className="invalid-feedback">
                          {projectForm.errors.projectName &&
                          projectForm.touched.projectName
                            ? projectForm.errors.projectName
                            : null}
                        </div>

                        <div className="mb-4 col-md-12">
                          <label className="form-label">Description</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-building-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="text"
                              name="projectDescription"
                              className={
                                "form-control" +
                                (projectForm.errors.projectDescription &&
                                projectForm.touched.projectDescription
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectDescription}
                              placeholder="Project Description"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {projectForm.errors.projectDescription &&
                            projectForm.touched.projectDescription
                              ? projectForm.errors.projectDescription
                              : null}
                          </div>
                        </div>

                        <div className="mb-4 col-md-12">
                          <label className="form-label">Project Status</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-map-marker"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="text"
                              name="projectStatusId"
                              className={
                                "form-control" +
                                (projectForm.errors.projectStatusId &&
                                projectForm.touched.projectStatusId
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectStatusId}
                              placeholder="Location"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {projectForm.errors.projectStatusId &&
                            projectForm.touched.projectStatusId
                              ? projectForm.errors.projectStatusId
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">Start Date</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-calendar-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="date"
                              name="projectStartDate"
                              className={
                                "form-control" +
                                (projectForm.errors.projectStartDate &&
                                projectForm.touched.projectStartDate
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectStartDate}
                              placeholder="Project Start Date"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {projectForm.errors.projectStartDate &&
                            projectForm.touched.projectStartDate
                              ? projectForm.errors.projectStartDate
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label className="form-label">End Date</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-calendar-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="date"
                              name="projectEndDate"
                              className={
                                "form-control" +
                                (projectForm.errors.projectEndDate &&
                                projectForm.touched.projectEndDate
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectEndDate}
                              placeholder="End Date"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {projectForm.errors.projectEndDate &&
                            projectForm.touched.projectEndDate
                              ? projectForm.errors.projectEndDate
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-12">
                          <label className="form-label">Kick-Off Date</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-calendar-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="date"
                              name="projectkickOffDate"
                              className={
                                "form-control" +
                                (projectForm.errors.projectkickOffDate &&
                                projectForm.touched.projectkickOffDate
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectkickOffDate}
                              placeholder="End Date"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {projectForm.errors.projectkickOffDate &&
                            projectForm.touched.projectkickOffDate
                              ? projectForm.errors.projectkickOffDate
                              : null}
                          </div>
                        </div>

                        <div className="mb-4 col-md-12">
                          <label className="form-label">Technology</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-building-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="text"
                              name="projectTechnology"
                              className={
                                "form-control" +
                                (projectForm.errors.projectTechnology &&
                                projectForm.touched.projectTechnology
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectTechnology}
                              placeholder="ProjectDetails"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {projectForm.errors.projectTechnology &&
                            projectForm.touched.projectTechnology
                              ? projectForm.errors.projectTechnology
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-12">
                          <label className="form-label">Project Code</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-building-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <input
                              type="text"
                              name="projectCode"
                              className="form-control"
                              onChange={projectForm.handleChange}
                              value={projectForm.values.projectCode}
                              placeholder="Responsibilities"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer m-auto">
                        <button type="submit" className="savebtn-click">
                          Save Changes
                        </button>
                        <button
                          type="button"
                          className="cancel-click"
                          data-bs-dismiss="modal"
                          onClick={handleCloseAddProjectModal}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div>{loader ? <Preloader /> : ""}</div>
      </div>
    </div>
  );
}
export default ProjectDetail;
